import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';

/** The single checkout every purchase button leads to. */
export const CHECKOUT_URL = 'https://babysleepbible.impultienda.ar/checkout';

/** Anchor of the final offer block, where the checkout button lives. */
export const OFFER_ANCHOR = '#offer';
export const CURRENCY_NOTE = 'Payments are processed in your local currency';
interface CtaButtonProps {
  label: string;
  /** 'checkout' opens the checkout; 'offer' scrolls down to the final offer. */
  action?: 'checkout' | 'offer';
  className?: string;
  size?: 'md' | 'lg';
}
export function CtaButton({
  label,
  action = 'checkout',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  const sizing = size === 'lg' ? 'px-8 py-4 text-[13px] sm:text-sm' : 'px-5 py-3 text-[13px]';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className={`group inline-flex items-center justify-center gap-2.5 rounded-[12px] bg-brand-green font-body font-semibold uppercase tracking-[0.08em] text-brand-green-text transition-colors duration-200 ease-out hover:bg-brand-green-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green focus-visible:ring-offset-2 focus-visible:ring-offset-brand-ivory ${sizing} ${className}`} data-id="element-1" data-mp="19bbg3v0fb1dz">
      <span data-id="element-2" data-mp="3owa1sck2jzov">{label}</span>
      <span aria-hidden="true" className="text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-3" data-mp="3owti5ou2mg0s">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  /** Small line above the button, e.g. what is included. */
  meta?: string;
  /** Only the final checkout block shows the price and the currency note. */
  action?: 'checkout' | 'offer';
  className?: string;
}

/**
 * Centered call-to-action block. The price appears only on the checkout block
 * (the last one on the page); every other button scrolls there instead.
 */
export function CtaBlock({
  label,
  meta,
  action = 'offer',
  className = ''
}: CtaBlockProps) {
  const isCheckout = action === 'checkout';
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-4" data-mp="3hwjdo3g5tzcf">
      {meta && <p className="font-body text-[11px] uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-5" data-mp="jpdfv9pfdy9">
          {meta}
        </p>}
      {isCheckout && <>
          <p className="mt-3 font-body text-[2.25rem] font-bold leading-none tracking-[-0.01em] text-brand-charcoal" data-id="element-6" data-mp="9gzopgmiv336">
            23 USD
          </p>
          <p className="mt-2.5 font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-7" data-mp="jggr9p6h90ux">
            {CURRENCY_NOTE}
          </p>
        </>}
      <CtaButton label={label} action={action} className={`${meta || isCheckout ? 'mt-4' : ''} w-full sm:w-auto`} data-id="element-8" data-mp="efkojexv3kr3" />
    </div>;
}